import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-status-update-document-note',
  templateUrl: './add-status-update-document-note.component.html',
  styleUrls: ['./add-status-update-document-note.component.scss']
})
export class AddStatusUpdateDocumentNoteComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
